import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Contact from "./componet/Contact";
import Home from "./componet/Home";
import PrivateRoute from "./componet/PrivateRoute";

import Sub from "./componet/Sub";




function Routes() {
  return (
    <div>
      <BrowserRouter>

        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/contact" exact component={Contact} />
          {/* <Route path="/signup" exact component={Signup} /> */}
          <PrivateRoute path="/sub" exact component={Sub} />

        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default Routes;
